<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Saugos pranešimas (LT)"
                type="text"
                required
                :disabled="modeReadonly"
                :maxlength="2000"
                v-model="formData.title_lt"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Saugos pranešimas (EN)"
                type="text"
                required
                :maxlength="2000"
                :disabled="modeReadonly"
                v-model="formData.title_en"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-file-input
                label="Saugos pranešimo dokumentas (LT)"
                required
                v-model="files.file_lt"
                :fileData="formData.file_lt"
                :disabled="modeReadonly"
                @addFile="addFile($event, 'file_lt')"
                @clearFile="clearFile($event, 'file_lt')"
              ></el-file-input>
            </v-col>
            <v-col cols="12" md="6">
              <el-file-input
                label="Saugos pranešimo dokumentas (EN)"
                required
                v-model="files.file_en"
                :fileData="formData.file_en"
                :disabled="modeReadonly"
                @addFile="addFile($event, 'file_en')"
                @clearFile="clearFile($event, 'file_en')"
              ></el-file-input>
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :disabled="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-autocomplete
                :items="classifiers.roles"
                itemvalue="value"
                multiple
                itemtext="text"
                label="Rolė"
                required
                v-model="formData.roles"
                longText
                seperate
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import upload from '@/mixins/upload'
export default {
  name: 'AdminSecurityNotificationForm',
  components: {},
  mixins: [userRole, upload],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {},
      role_list: [],
      files: {},
      uploadedFiles: {},
      classifiers: [],
    }
  },
  computed: {
    getUploadedFiles() {
      return this.uploadedFiles
    },

    modeReadonly() {
      return false
    },

    getId() {
      return this.$route.params.id || null
    },

    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti saugos pranešimą`)
      } else {
        return this.$t(`Naujas saugos pranešimas`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    } else {
      this.getClassifiers()
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierSecurityNotifications' })
    },
    async getClassifiers() {
      this.pageloading = true
      let requiredClassifiers = { classifiers: ['roles'] }
      await this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    async getData() {
      this.pageloading = true
      await this.getClassifiers()
      this.$axios
        .get(`security-notifications/${this.getId}`)
        .then((res) => {
          this.formData = res.data.securityNotification
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    addFile(file, name) {
      this.addUploadedFiles(file, name)
    },

    clearFile(event, name) {
      if (name && this.uploadedFiles.hasOwnProperty(name)) {
        delete this.uploadedFiles[name]
      }
    },
    addUploadedFiles(element, name) {
      if (element != null) {
        // let tipas = element.name.toLowerCase().split('.').pop()
        // if (!this.fileTypeList.includes(tipas)) {
        //   this.$root.$emit(
        //     'DATA_ERROR',
        //     'Netinkamas dokumento formatas, galima įkelti tik PDF, ADOC ir ASICE'
        //   )
        //   return
        // }
        // if (element.size > this.maxDydisByte) {
        //   this.$root.$emit(
        //     'DATA_ERROR',
        //     `Leistinas dokumento dydis: ${this.maxDydis} MB`
        //   )
        //   return
        // }
        this.uploadedFiles[name] = element
      }
    },
    saveData() {
      if(this.getMaxUploadSize(20)){
        return this.$root.$emit('DATA_ERROR_DIRECT_TEXT', this.getMaxUploadSizeMsg(20))
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()

          Object.keys(this.uploadedFiles).map((key) => {
            formData.append(key, this.uploadedFiles[key])
          })
          formData.append('title_lt', this.formData.title_lt)
          formData.append('title_en', this.formData.title_en)
          formData.append('valid_from', this.formData.valid_from)
          formData.append('valid_to', this.formData.valid_to ?? '')
          formData.append('roles', this.formData.roles)
          
          let url = `security-notifications`
          this.getId && formData.append('id', this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
